<template>
    <div class="v4y-info-box pb-2">
        <div class="mx-4 py-3 d-flex align-items-center whitespace-nowrap text-nowrap">
            <span class="ms-2 me-3">
                <info_icon_gelb></info_icon_gelb>
            </span>
            <b>Bitte beachten Sie</b>
        </div>
        <div class="mx-4 mb-3">
            Der Download des PDF-Dokuments öffnet ggf. einen  neuen Tab in Ihrem Browser. Bitte kehren Sie nach dem Download zurück zu diesem Tab, um den Vertrag abschließen zu können.
        </div>
    </div>
</template>

<script setup>
import info_icon_gelb from '@/components/icons/info_icon_gelb.vue';
</script>